import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import UnitsIndex from './units/Index.vue';
import UnitEdit from './units/Edit.vue';
import GalleryIndex from './gallery/Index.vue';
import GalleryEdit from './gallery/Edit.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/captain'),
      meta: {
        permissions: ['administrator'],
        featureFlag: FEATURE_FLAGS.CAPTAIN,
      },
      component: SettingsWrapper,
      props: {
        headerTitle: 'CAPTAIN_SETTINGS.TITLE',
        icon: 'i-lucide-bot',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'captain_settings_index',
          component: Index,
          meta: {
            permissions: ['administrator'],
            featureFlag: FEATURE_FLAGS.CAPTAIN,
            installationTypes: [
              INSTALLATION_TYPES.ENTERPRISE,
              INSTALLATION_TYPES.CLOUD,
            ],
          },
        },
        {
          path: 'units',
          name: 'captain_settings_units',
          component: UnitsIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'units/:id/edit',
          name: 'captain_settings_units_edit',
          component: UnitEdit,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'gallery',
          name: 'captain_settings_gallery',
          component: GalleryIndex,
          meta: {
            permissions: ['administrator', 'agent'],
          },
        },
        {
          path: 'gallery/:id/edit',
          name: 'captain_settings_gallery_edit',
          component: GalleryEdit,
          meta: {
            permissions: ['administrator', 'agent'],
          },
        },
      ],
    },
  ],
};
